(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jewelry-home-animations"] && !Shopify.designMode) return;
  try {
    
  function initJewelryHomeReveal() {
    if (window.jewelryHomeRevealObserver) {
      window.jewelryHomeRevealObserver.disconnect();
    }

    var controller = document.querySelector('.jewelry-home-animations');
    var main = document.querySelector('main[data-template="index"]');

    if (!controller || !main || controller.dataset.enabled !== 'true') {
      document.body.classList.remove('jewelry-home-reveal-enabled');
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.body.classList.remove('jewelry-home-reveal-enabled');
      return;
    }

    var duration = parseInt(controller.dataset.duration, 10) || 850;
    var distance = parseInt(controller.dataset.distance, 10) || 24;
    var stagger = parseInt(controller.dataset.stagger, 10) || 90;
    var animateOnce = controller.dataset.once !== 'false';

    document.body.style.setProperty('--jewelry-reveal-duration', duration + 'ms');
    document.body.style.setProperty('--jewelry-reveal-distance', distance + 'px');
    document.body.classList.add('jewelry-home-reveal-enabled');

    main.querySelectorAll('[data-jewelry-reveal]').forEach(function (target) {
      target.removeAttribute('data-jewelry-reveal');
      target.classList.remove('jewelry-reveal-visible');
      target.style.removeProperty('--jewelry-reveal-delay');
    });

    var selectors = [
      '.hero',
      '.jewelry-category-showcase__header',
      '.jewelry-category-showcase__item',
      '.section-content-wrapper',
      '.group-block',
      '.jewelry-shop-the-look__media',
      '.jewelry-shop-the-look__copy',
      '.jewelry-shop-the-look__product-slide',
      '.jewelry-product-card',
      '.product-card',
      '.jewelry-brand-story__copy',
      '.jewelry-brand-story__media',
      '.jewelry-testimonials__header',
      '.jewelry-testimonials__card'
    ];

    var sections = main.querySelectorAll('.shopify-section');
    var targets = [];

    sections.forEach(function (section) {
      if (section.classList.contains('section-wrapper--jewelry-home-animations')) {
        return;
      }

      if (section.querySelector('.jewelry-newsletter-popup-section')) {
        return;
      }

      var sectionTargets = section.querySelectorAll(selectors.join(','));

      if (!sectionTargets.length) {
        sectionTargets = section.children;
      }

      Array.prototype.forEach.call(sectionTargets, function (target, index) {
        if (!target || target.closest('.jewelry-home-animations, dialog')) {
          return;
        }

        if (targets.indexOf(target) !== -1) {
          return;
        }

        target.dataset.jewelryReveal = '';
        target.dataset.jewelryRevealShown = 'false';
        target.style.setProperty('--jewelry-reveal-delay', Math.min(index * stagger, 320) + 'ms');
        targets.push(target);
      });
    });

    if (!targets.length) {
      return;
    }

    function revealTarget(target) {
      if (animateOnce && target.dataset.jewelryRevealShown === 'true') {
        return;
      }

      target.classList.add('jewelry-reveal-visible');
      target.dataset.jewelryRevealShown = 'true';

      if (typeof target.animate === 'function') {
        var delay = parseInt(target.style.getPropertyValue('--jewelry-reveal-delay'), 10) || 0;

        target.animate(
          [
            { opacity: 0, transform: 'translate3d(0, ' + distance + 'px, 0)' },
            { opacity: 1, transform: 'translate3d(0, 0, 0)' }
          ],
          {
            duration: duration,
            delay: delay,
            easing: 'cubic-bezier(0.21, 0.61, 0.35, 1)',
            fill: 'backwards'
          }
        );
      }
    }

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (target) {
        revealTarget(target);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            revealTarget(entry.target);

            if (animateOnce) {
              observer.unobserve(entry.target);
            }
          } else if (!animateOnce) {
            entry.target.classList.remove('jewelry-reveal-visible');
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    window.jewelryHomeRevealObserver = observer;

    requestAnimationFrame(function () {
      targets.forEach(function (target) {
        observer.observe(target);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJewelryHomeReveal);
  } else {
    initJewelryHomeReveal();
  }

  document.addEventListener('shopify:section:load', initJewelryHomeReveal);
  document.addEventListener('shopify:section:reorder', initJewelryHomeReveal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jewelry-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  const initNewsletterPopup = (root) => {
    if (!root || root.dataset.initialized === 'true') return;

    const dialog = root.querySelector('dialog');
    if (!dialog) return;

    root.dataset.initialized = 'true';

    const enabled = root.dataset.enabled === 'true';
    const designMode = root.dataset.designMode === 'true';
    const forceOpen = root.dataset.forceOpen === 'true' || Boolean(root.querySelector('.jewelry-newsletter-popup__message'));
    const delay = Math.max(Number(root.dataset.delay || 0), 0) * 1000;
    const frequency = root.dataset.frequency || 'once_per_session';
    const storageKey = `newsletter-popup-${root.dataset.popupId || 'default'}`;

    const hasStorageValue = (storage) => {
      try {
        return storage.getItem(storageKey);
      } catch (error) {
        return null;
      }
    };

    const setStorageValue = (storage, value) => {
      try {
        storage.setItem(storageKey, value);
      } catch (error) {
      }
    };

    const shouldShow = () => {
      if (forceOpen || designMode) return true;
      if (!enabled) return false;
      if (frequency === 'every_visit') return true;
      if (frequency === 'once_per_session') return hasStorageValue(window.sessionStorage) !== 'dismissed';

      const dismissedAt = Number(hasStorageValue(window.localStorage));
      const days = Number(frequency);
      if (!dismissedAt || !days) return true;

      return Date.now() - dismissedAt > days * 24 * 60 * 60 * 1000;
    };

    const rememberDismissed = () => {
      if (designMode) return;
      if (frequency === 'once_per_session') {
        setStorageValue(window.sessionStorage, 'dismissed');
        return;
      }
      if (frequency !== 'every_visit') {
        setStorageValue(window.localStorage, String(Date.now()));
      }
    };

    const openDialog = () => {
      if (dialog.open || !shouldShow()) return;

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    };

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        rememberDismissed();
        dialog.close();
      }
    });

    dialog.addEventListener('close', rememberDismissed);

    root.querySelectorAll('[data-newsletter-close]').forEach((button) => {
      button.addEventListener('click', () => {
        rememberDismissed();
        dialog.close();
      });
    });

    window.setTimeout(openDialog, forceOpen || designMode ? 0 : delay);
  };

  const initAllNewsletterPopups = (container = document) => {
    container.querySelectorAll('[data-newsletter-popup]').forEach(initNewsletterPopup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllNewsletterPopups());
  } else {
    initAllNewsletterPopups();
  }

  document.addEventListener('shopify:section:load', (event) => initAllNewsletterPopups(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jewelry-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  const setupShopTheLookCarousel = (carousel) => {
    if (carousel.dataset.shopTheLookReady === 'true') return;

    const track = carousel.querySelector('[data-shop-look-track]');
    const previous = carousel.querySelector('[data-shop-look-prev]');
    const next = carousel.querySelector('[data-shop-look-next]');

    if (!track) return;

    carousel.dataset.shopTheLookReady = 'true';

    const getScrollDistance = () => {
      const slide = track.querySelector('.jewelry-shop-the-look__product-slide');
      const style = window.getComputedStyle(track);
      const gap = Number.parseFloat(style.columnGap || style.gap || '0');

      return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
    };

    const updateButtons = () => {
      const maxScroll = track.scrollWidth - track.clientWidth - 1;

      if (previous) previous.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxScroll;
    };

    previous?.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollDistance(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      track.scrollBy({ left: getScrollDistance(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  };

  const initShopTheLookCarousels = (root = document) => {
    root.querySelectorAll('[data-shop-the-look-carousel]').forEach(setupShopTheLookCarousel);
  };

  initShopTheLookCarousels();
  document.addEventListener('shopify:section:load', (event) => initShopTheLookCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
